import { BREAKDOWN_KEY, BREAKDOWN_TYPE, BREAKDOWN_TYPES } from "../recipeImpactChart.constants";
import { ImpactBreakdown } from "../recipeImpactChart.types";
import { buildItemId, getBreakdownList } from "./breakdownItem.utill";

/**
 * Returns a deep-enriched copy of a breakdown with resolved chartColor on every
 * entry and patternIndex on process entries.
 *
 * Backend report PDF contract: chartColor + patternIndex live on breakdown items.
 */
export const enrichBreakdownWithChartStyle = (
  breakdown: ImpactBreakdown,
  colorById: Record<string, string>,
  patternIndexById: Record<string, number>
): ImpactBreakdown => {
  const enriched: ImpactBreakdown = { ...breakdown };

  BREAKDOWN_TYPES.forEach(type => {
    const list = getBreakdownList(breakdown, type);
    if (list.length === 0) return;

    enriched[BREAKDOWN_KEY[type]] = list.map(entry => {
      const id = buildItemId(entry, type);
      const styled: Record<string, any> = {
        ...entry,
        chartColor: colorById[id] ?? entry.chartColor
      };

      if (type === BREAKDOWN_TYPE.process && patternIndexById[id] !== undefined) {
        styled.patternIndex = patternIndexById[id];
      }

      return styled;
    });
  });

  return enriched;
};
